import api from "./axiosInstance";

// ✅ Get blogs (with filters)
export const getBlogs = (params) => {
  return api.get("/rss-blogs", { params });
};

// ✅ Trigger RSS sync (optional)
export const syncRSS = () => {
  return api.get("/rss-sync");
};